import React from "react";
import TZMDialog from "../../../components/dialog/TZMDialog";
import TZMTable from "../../../components/table/TZMTable";
import TZMColumn from "../../../components/table/TZMColumn";
import TZMPanelFooter from "../../../components/panel/TZMPanelFooter";
import TZMButton from "../../../components/common/TZMButton";
import TZMShortcut from "../../../utilities/TZMShortcut";
import { DataTable } from "primereact/components/datatable/DataTable";

export class LogsIntegracao extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			visible: true,
			logs: props.logs
		};
	}

	fechar = () => {
		this.setState({visible: false});
	}

	columnStatus(rowData) {
		let value, color, title;	
			switch (rowData.status) {				
			case "ERRO":
				value = "times";
				color = "#F44336";
				title = "Erro";
				break;
			case "PROCESSADO":
				value = "thumbs-up";
				color = "#0558e7";
				title = "Processado";
				break;
			default:
				value = "clock";
				color = "#2196F3";
				title = "Aguardando Processamento ";
				break;
			}
		
		return <span key="columnStatus" className={`fas fa-${value}`} title={title} style={{color}} />;
	}

	columns = [
		<TZMColumn header="Tipo" field="tipo" style={{width: "5em",  textAlign: "center"}} />,
		<TZMColumn field="item" style={{width: "5em", textAlign: "center"}} />,
		<TZMColumn header="Status" style={{width: "5em", textAlign: "center"}} body={this.columnStatus} />,		
		<TZMColumn header="Manutenção" field="tipoManutencao" style={{width: "8em",  textAlign: "center"}} />,
		<TZMColumn header="Mensagem" field="mensagemErro" style={{width: "*"}} />,		
	];

	render() {
		return (
			<TZMDialog style={{width: "1000px"}} visible={this.state.visible} modal header="Registros de Integração" {...this.props}>
				<div className="ui-g">
					<DataTable ref={(el) => this.dt = el} value={this.state.logs} paginator rows={15} >
						{this.columns}
					</DataTable>
				</div>
				<TZMPanelFooter>
					<TZMButton secondary label="Fechar" icon="fas fa-close" onClick={this.fechar} />
				</TZMPanelFooter>
				<TZMShortcut active={this.state.visible}
					onEscape={this.fechar}
				/>
			</TZMDialog>
		);
	}

}
